<template>
  <div class="zl_rate">
    <div class="rateBox">
      <span class="el-icon-close" @click="closeThis"></span>
      <div id="lottieDiv"></div>
      <div class="scoreandstar">
        <el-rate
          style="margin-bottom: 10px;"
          v-model="value"
          disabled
          :colors="['#ac7b36', '#ac7b36', '#ac7b36']"
          score-template="{value}">
        </el-rate>
        <span>我的得分</span>

      </div>
      <span class="rateBtn" @click="handleClick">进入下一节</span>
    </div>
  </div>
</template>
<script>
  /**
   *   json 动图
   *   wjl
   *   2022.8.23
   */
  import sbadge from "../assets/lottie/sbadge.json";
  import jbadge from "../assets/lottie/jbadge.json";
  import lottie from "lottie-web";
  export default {
    name:'zl_rate',
    props: {
      value: {
        type: Number,
        default: 0,
      },
      nextClick: {
        type: Function,
        default: ()=>{}
      },
      closeFn: {
        type: Function,
        default: ()=>{}
      },
    },
    data() {
      return {};
    },
    mounted() {
      this.svgFun();
    },
    methods: {
      svgFun() {
         lottie.loadAnimation({
          container: document.getElementById("lottieDiv"),
          renderer: "svg",  // 渲染方式:svg：支持交互、不会失帧、canvas、html：支持3D，支持交互
          loop: false,
          autoplay: true,
          animationData: this.value > 0? sbadge : jbadge,
        })
      },
      // 出发事件
      handleClick(){
        if (this.nextClick && typeof this.nextClick == 'function'){
          this.nextClick()
        }
      },
      closeThis(){
        if (this.closeFn && typeof this.closeFn == 'function'){
          this.closeFn()
        }
      }
    },
  };
</script>
<style lang='scss' scoped>
  .zl_rate {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 20000;
    background: rgba(0,0,0,0.5);
    .rateBox{
      width: 615px;
      height: 523px;
      background: #1B1D49;
      border-radius: 4px;
      position: relative;
      .el-icon-close{
        cursor: pointer;
        color: #cccccc;
        font-size: 18px;
        position: absolute;
        right: -30px;
        top: 0;
      }
      .scoreandstar{
        width: 50%;
        height: 70px;
        background: linear-gradient(145deg, #F9EFD3, #F0DAA7);
        box-shadow: 0px 4px 4px 0px rgba(213,182,126,0.17), inset 4px -3px 12px 3px rgba(255,255,255,0.07);
        border-radius: 6px;
        position: absolute;
        bottom: 150px;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        font-size: 12px;
        font-weight: 600;
        color: #74572E;
      }
      .rateBtn{
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: 40px;
        width: 110px;
        height: 38px;
        line-height: 38px;
        text-align: center;
        background: #323459;
        border-radius: 4px;
        font-weight: 600;
        color: #FFFFFF;
        font-size: 14px;
        cursor: pointer;
      }
    }

    /deep/ .el-rate {
      height: auto;
      line-height: initial;

      .el-rate__icon,
      .el-rate__decimal,
      .el-icon-star-on {
        font-size: 30px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/zl_rate.vue